import { Component, OnDestroy, OnInit } from '@angular/core';
import { WhiteLabelService } from '@core/services/white-label/white-label.service';
import { NavigationService } from '@core/services/navigation.service';
import { SelectedAccountStore } from '@core/stores/selected-account-store.service';
import { pairwise } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    subscription: Subscription;

    constructor(
        private whiteLabelService: WhiteLabelService,
        private navigationService: NavigationService,
        private selectedAccountStore: SelectedAccountStore,
        private location: Location
    ) {
        this.navigationService.initialize();
    }

    async ngOnInit(): Promise<void> {
        await this.whiteLabelService.apply();

        this.subscription = this.selectedAccountStore.selectedAccount$
            .pipe(pairwise())
            .subscribe(([previous, current]) => {
                if (!!previous && !!current && previous.role !== current.role) {
                    this.location.historyGo(0);
                }
            });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
